/**
 * Visningsetikett: understreck → mellanrum, varje ord med stor begynnelsebokstav
 * (ic_hold → Ic Hold, company_candidates_found → Company Candidates Found).
 */
export function prettifyStatusLabel(s) {
  if (s == null || s === "") return s;
  return String(s)
    .split("_")
    .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : ""))
    .join(" ");
}
